/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Record_DetailInputs */

const en_portal_view_record_detail = /** @type {(inputs: Portal_View_Record_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squat 80 kg · +12.5 kg`)
};

const pl_portal_view_record_detail = /** @type {(inputs: Portal_View_Record_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przysiad 80 kg · +12,5 kg`)
};

/**
* | output |
* | --- |
* | "Squat 80 kg · +12.5 kg" |
*
* @param {Portal_View_Record_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_record_detail = /** @type {((inputs?: Portal_View_Record_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Record_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_record_detail(inputs)
	return en_portal_view_record_detail(inputs)
});